var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripeCoupons = function SvgStripeCoupons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.225 1.327c-.864.067-1.516.687-1.598 1.549a40 40 0 0 0-.14 2.243c-.013.357.231.663.542.84a2.46 2.46 0 0 1 1.243 2.14A2.46 2.46 0 0 1 2.03 10.24c-.31.177-.555.483-.541.84.036.966.088 1.698.14 2.243.081.862.733 1.482 1.597 1.549 1.194.092 3.289.192 6.775.192s5.58-.1 6.775-.192c.864-.067 1.516-.687 1.598-1.549.051-.545.103-1.277.14-2.243.012-.356-.232-.663-.542-.84a2.46 2.46 0 0 1-1.243-2.14 2.46 2.46 0 0 1 1.243-2.141c.31-.177.555-.483.541-.84a40 40 0 0 0-.14-2.243c-.081-.862-.733-1.482-1.597-1.549-1.194-.092-3.289-.192-6.775-.192s-5.58.1-6.775.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.49 11.558q.38-.41.379-1.142 0-.723-.378-1.133-.38-.41-.976-.41-.606 0-.984.41-.37.41-.37 1.133 0 .732.37 1.142.378.41.984.41.597 0 .976-.41M8.46 6.916q.38-.411.38-1.143 0-.722-.38-1.132-.378-.41-.975-.41-.606 0-.984.41-.37.41-.37 1.132 0 .733.37 1.143.378.41.984.41.597 0 .976-.41M13.095 5.004l-6.19 6.19"
  }))));
};
export default SvgStripeCoupons;